import React, { FormHTMLAttributes, forwardRef } from "react";
// 1. Import the new CSS file
import "./form.module.css";

// UI props interface
export interface FormUIProps {
    uiPadding?: boolean;
}

// Full props type
export type FormProps = FormHTMLAttributes<HTMLFormElement> & FormUIProps;

/**
 * Simple flex form
 */
const Form = forwardRef<HTMLFormElement, FormProps>(
    (
        {
            // Destructure UI props
            uiPadding = true, // Set default from defaultProps
            
            // Destructure standard props
            className,
            children,
            ...other
        },
        ref
    ) => {
        
        // 2. Build the list of CSS classes
        const classNames = [
            "form-base", // Base class for the form
            "dimmable",  // The class for your dimmable styles
            uiPadding ? "form-padding" : "", // Class for padding
            className,   // Pass through any parent class
        ]
            .filter(Boolean)
            .join(" ");

        // 3. Render the standard <form> element
        return (
            <form ref={ref} className={classNames} {...other}>
                {children}
            </form>
        );
    }
);

Form.displayName = "Form";

export default Form;
